import { IonSpinner } from '@ionic/react';
import React from 'react';
import CamelotKeyChip from '../tracks/CamelotKeyChip';
import { AgentAttachedTrack } from './agentAttachedTrack';

export const AgentTrackSearchResults: React.FC<{
  results: AgentAttachedTrack[];
  activeIndex: number;
  isSearching: boolean;
  query: string;
  onActiveIndexChange: (index: number) => void;
  onSelect: (track: AgentAttachedTrack) => void;
  className?: string;
}> = ({
  results,
  activeIndex,
  isSearching,
  query,
  onActiveIndexChange,
  onSelect,
  className,
}) => {
  const trimmed = query.trim();
  const showHint = trimmed.length < 3;
  const showEmpty = trimmed.length >= 3 && !isSearching && results.length === 0;

  if (!showHint && !isSearching && results.length === 0 && !showEmpty) {
    return null;
  }

  return (
    <div
      className={`agent-track-search-results${className ? ` ${className}` : ''}`}
    >
      {isSearching && (
        <div className="agent-track-search-status">
          <IonSpinner name="dots" />
        </div>
      )}
      {showHint && (
        <p className="agent-track-search-hint">Type 3+ characters to search</p>
      )}
      {showEmpty && <p className="agent-track-search-hint">No tracks found</p>}
      {results.length > 0 && (
        <div className="agent-track-search-list">
          {results.map((track, index) => (
            <button
              key={`${track.id}-${index}`}
              type="button"
              className={`agent-track-search-row${
                index === activeIndex ? ' is-active' : ''
              }`}
              onMouseEnter={() => onActiveIndexChange(index)}
              onMouseDown={(event) => event.preventDefault()}
              onClick={() => onSelect(track)}
            >
              {track.albumCover ? (
                <img src={track.albumCover} alt="" />
              ) : (
                <span className="agent-track-search-art-fallback" />
              )}
              <span className="agent-track-search-copy">
                <span className="agent-track-search-title">{track.title}</span>
                <span className="agent-track-search-artist">
                  {track.artist}
                </span>
              </span>
              <span className="agent-track-search-meta">
                {track.key && <CamelotKeyChip value={track.key} />}
                {track.bpm > 0 && (
                  <span>
                    {track.bpm}
                    <span className="bpm-unit"> bpm</span>
                  </span>
                )}
              </span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default AgentTrackSearchResults;
